import { Component } from '@angular/core';
import { LoadingController, NavParams, ViewController,ModalController } from 'ionic-angular';
import * as firebase from 'firebase/app';
import * as moment from 'moment';

@Component({selector: 'page-counters', templateUrl: 'counters.html'})
export class CountersPage {
  dia = moment().startOf('day').format();
  ok : boolean = false;
  accounts = {};
  foods = {};
  _foods = [];
  plans = {};
  _plans = [];
  customers = {};
  full_data = {};
  data = {};
  max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  nocustomers_detail : boolean = false;
  constructor(
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController) {
    firebase.database().ref('/accounts').once('value').then((snapshot)=>{
      this.accounts = snapshot.val();
    });
    firebase.database().ref('/customers').once('value').then((snapshot)=>{
      this.customers = snapshot.val();
    });

    firebase.database().ref('/plans').once('value').then((snapshot)=>{
      this.plans = snapshot.val();
      this._plans = Object.keys(this.plans);
    });

    this.data = {
      print : 0,
      noprint : 0,
      suspend : [],
      inactive: [],
      notready : [],
      notday : [],
      total_customers : 0,
      owner : "",
      hour : "",
      women : 0,
      men : 0,
      foods : {},
      plans : {}
    };
  }

  ionViewWillEnter() {
    this.changeDate();
  }

  getName(user){
    if(Object.keys(this.accounts).length>0){
      return this.accounts[user].name;
    }
  }

  toArray(plans){
    if(plans){
      return Object.keys(plans).map(function(key) {
        return plans[key];
      });
    }
  }

  view(cust,title){

    if(cust && Object.keys(this.customers).length>0){
      let customers = [];
      for(let c=0;c<cust.length;c++){
        let cu = this.customers[cust[c]];
        cu.noshipping_aditional_info = '';
        let af = this.full_data["data"][cust[c]].noshipping_aditional_info;
        if(title=="su") cu.noshipping_aditional_info = "Suspendido por "+this.accounts[af.owner].name+" el "+moment(af.datetime).format('llll');
        if(title=="fi") cu.noshipping_aditional_info = 'Comienza el servicio el '+ moment(af).format('llll')
        cu.key = cust[c];
        customers.push(cu);
      }
      console.log(customers);
      let modal = this.modalCtrl.create(CounterViewPage, {title: title, customers : customers});
      modal.present();
    }
  }

  process(d){
    this.data = {
      print : 0,
      noprint : 0,
      suspend : [],
      inactive: [],
      notready : [],
      notday : [],
      ready:[],
      total_customers : 0,
      owner : "",
      hour : "",
      women : 0,
      men : 0,
      foods : {},
      plans : {}
    };
    this.data["owner"] = this.accounts[d.owner].name;
    this.data["hour"] = moment(d.date_client).format('LTS');
    this.data["total_customers"] = Object.keys(d.data).length;
    let foods = {};
    let plans = {};
    Object.keys(d.data).map((key) => {
      let de = d.data[key];

      if(de.shipping){
        this.data['ready'].push(key);
        if(de.gender=="M") this.data["men"]++;
        if(de.gender=="F") this.data["women"]++;
        this.data["print"]++;
        for(let f=0;f<de.foods.length;f++){
          let food_key = de.foods[f]['food_key'];
          if(foods[food_key]){
            foods[food_key][de.gender]++;
          }else{
            foods[food_key] = {
              M : 0,
              F : 0
            };
            foods[food_key][de.gender] = 1;

            this.foods[food_key] = de.foods[f]['food_name'];
          }
        }

        if(plans[de.plan_name]){plans[de.plan_name]++;}else{plans[de.plan_name]=1}
      }else{
        this.data["noprint"]++;
        if(de.noshipping_reason=="su") this.data["suspend"].push(key);
        if(de.noshipping_reason=="in") this.data["inactive"].push(key);
        if(de.noshipping_reason=="fi") this.data["notready"].push(key);
        if(de.noshipping_reason=="rd") this.data["notday"].push(key);
      }
    });
    console.log(this.plans,plans);
    this._foods = Object.keys(foods);
    this._plans = Object.keys(plans);
    this.data["foods"] = foods;
    this.data["plans"] = plans;
  }

  changeDate(){
    let loading = this.loadingCtrl.create({
      content: 'Buscando etiquetas del día '+moment(this.dia).format("LLLL")
    });
    loading.present();
    setTimeout(() => {
      let fecha = moment(this.dia).format("YYYYMMDD");
      this.ok = false;
      firebase.database().ref('/charges/'+fecha).once('value').then((snapshot)=>{
        if(snapshot.exists()){
          this.ok = true;
          this.full_data = snapshot.val();
          this.process(snapshot.val());
        }
      });
      loading.dismiss();
    },100);
  }

  getHour(date){
    if(date){
      return moment(date).format("LTS");
    }
  }
}
@Component({template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      {{title}}
    </ion-title>
    <ion-buttons end>
      <button ion-button (click)="dismiss()">
        <span ion-text color="primary">Cancelar</span>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-searchbar (ionInput)="getItems($event)"></ion-searchbar>
  <ion-list>
    <ion-item *ngFor="let item of items">
      [{{ item.name }} {{item.lastname}}] {{item.noshipping_aditional_info}}
    </ion-item>
  </ion-list>
</ion-content>
`})
export class CounterViewPage {
  title : String;
  items;
  reason;
  constructor(
    public viewCtrl: ViewController,
    public params: NavParams
  ) {
    this.initializeItems();
    this.reason = this.params.get('title');
    if(this.reason=="su") this.title="Suspendidos";
    if(this.reason=="in") this.title="Ex Clientes";
    if(this.reason=="fi") this.title="Fecha Ingreso Futura";
    if(this.reason=="rd") this.title="Día Restringido";

  }

  initializeItems() {
    this.items = this.params.get('customers');
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((item.name.toLowerCase().indexOf(val.toLowerCase()) > -1)||(item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/menus/counters.ts